import photo3B3 from '../360photos/3B 3.jpg';
import photo3B2 from '../360photos/3B 2.jpg';
import photo3B1 from '../360photos/3B 1.jpg';
import photo3B_3601 from '../360photos/3B_360_1.jpg';
import photo3A2 from '../360photos/3A_360_2.jpg';
import photo3AB3 from '../360photos/3AB_360_3.jpg';
import photo3AB4 from '../360photos/3AB_360_4.jpg';
import photo3AB5 from '../360photos/3AB_360_5.jpg';
import photo2B1 from '../360photos/2B_360_1.jpg';
import photo2B2 from '../360photos/2B_360_2.jpg';
import photo2B3 from '../360photos/2B_360_3.jpg';
import photo2B4 from '../360photos/2B_360_4.jpg';

import photo3B3_alt from '../360photos/3B 3_alt.jpg';
import photo3B2_alt from '../360photos/3B 2_alt.jpg';
import photo3B1_alt from '../360photos/3B 1_alt.jpg';
import photo3B_3601_alt from '../360photos/3B_360_1_alt.jpg';
import photo3A2_alt from '../360photos/3A_360_2_alt.jpg';
import photo3AB3_alt from '../360photos/3AB_360_3_alt.jpg';
import photo3AB4_alt from '../360photos/3AB_360_4_alt.jpg';
import photo3AB5_alt from '../360photos/3AB_360_5_alt.jpg';
import photo2B1_alt from '../360photos/2B_360_1_alt.jpg';
import photo2B2_alt from '../360photos/2B_360_2_alt.jpg';
import photo2B3_alt from '../360photos/2B_360_3_alt.jpg';
import photo2B4_alt from '../360photos/2B_360_4_alt.jpg';

export const hotSpots = [
  {
    fileName: '3A_360_2.jpg',
    key: '1',
    pitch: -150,
    yaw: -10,
    text:
      'Kasvilajivalinnoissa on otettu huomioon syysvärit, kukintojen erilaiset ajankohdat ja talviajan ilme.',
    itemType: 'HotSpot',
    type: 'info'
  },
  {
    fileName: '3A_360_2.jpg',
    key: '2',
    pitch: -150,
    yaw: 60,
    text:
      'Kasvillisuussuunnittelussa suositaan monilajisia sekä kerroksellisia puu-, perenna- ja pensasistutuksia tukemaan kaupunkiekologiaa ja luonnon monimuotoisuutta. \n',
    itemType: 'HotSpot',
    type: 'info'
  },
  {
    fileName: '3B_360_1.jpg',
    key: '1',
    pitch: -140,
    yaw: 80,
    text:
      'Polkupyörän voi jättää jokaisen pysäkin läheisyyteen. Raitiotien läheisyydessä on myös kaupunkipyöräasemia. ',
    itemType: 'HotSpot',
    type: 'info'
  },
  {
    fileName: '3B_360_1.jpg',
    key: '2',
    pitch: -30,
    yaw: 150,
    text:
      'Kasvilajivalinnoilla voidaan luoda ravintoa ja elinympäristöjä pölyttäjille, korvaavia elinympäristöjä paahde- ja perinneympäristöjen harvinaistuville kasvilajeille sekä ekologisia verkostoja viheralueiden välille. Kuvassa esitetty viitteelisesti kasvillisuus.',
    itemType: 'HotSpot',
    type: 'info'
  },
  {
    fileName: '3B 1.jpg',
    key: '1',
    pitch: 0,
    yaw: -90,
    text:
      'Raitiotien ja katujen suunnittelussa on haettu ratkaisuja, joissa toteutuu kiertotalous, kestävyys ja luonnon monimuotoisuus.',
    itemType: 'HotSpot',
    type: 'info'
  },
  {
    fileName: '3B 1.jpg',
    key: '2',
    pitch: -10,
    yaw: -10,
    text: 'Aina kun mahdollista, raitiotie toteutetaan viherraiteena.',
    itemType: 'HotSpot',
    type: 'info'
  },
  {
    fileName: '3B 2.jpg',
    key: '1',
    pitch: -10,
    yaw: -250,
    text:
      'Nupu- ja noppakiveyksissä käytetään kaupungin varastoista saatavia ylijäämäkiviä ja kierrätettyä katukiviä. ',
    itemType: 'HotSpot',
    type: 'info'
  },
  {
    fileName: '3B 2.jpg',
    key: '2',
    pitch: 0,
    yaw: -220,
    text:
      'Monimuotoisuus lisää kasvillisuuden vastustuskykyä ilmastonmuutoksen myötä lisääntyviä tuholaisia vastaan. Kuvassa esitetty viitteelisesti  kasvillisuus.',
    itemType: 'HotSpot',
    type: 'info'
  },
  {
    fileName: '3B 3.jpg',
    key: '1',
    pitch: 0,
    yaw: -220,
    text:
      'Kasvillisuussuunnittelussa otetaan huomioon myös syysvärit, kukintojen erilaiset ajankohdat ja talviajan ilme. ',
    itemType: 'HotSpot',
    type: 'info'
  },
  {
    fileName: '3B 3.jpg',
    key: '2',
    pitch: -30,
    yaw: -230,
    text:
      'Nupu- ja noppakiveyksissä käytetään kaupungin varastoista saatavia ylijäämäkiviä ja kierrätettyä katukiviä.',
    itemType: 'HotSpot',
    type: 'info'
  },
  {
    fileName: '3B 3.jpg',
    key: '3',
    pitch: 0,
    yaw: -200,
    text:
      'Vihreän infran suunnittelussa suositaan monilajisia sekä kerroksellisia puu-, perenna- ja pensasistutuksia tukemaan kaupunkiekologiaa',
    itemType: 'HotSpot',
    type: 'info'
  },
  {
    fileName: '2B_360_1.jpg',
    key: '1',
    pitch: -25,
    yaw: -205,
    text:
      'Nupu- ja noppakiveyksissä käytetään kaupungin varastoista saatavia ylijäämäkiviä ja kierrätettyä katukiviä. ',
    itemType: 'HotSpot',
    type: 'info'
  },
  {
    fileName: '2B_360_1.jpg',
    key: '2',
    pitch: -2,
    yaw: -220,
    text:
      'Polkupyörän voi jättää jokaisen pysäkin läheisyyteen. Raitiotien läheisyydessä on myös kaupunkipyöräasemia. ',
    itemType: 'HotSpot',
    type: 'info'
  },
  {
    fileName: '2B_360_2.jpg',
    key: '1',
    pitch: 0,
    yaw: -60,
    text:
      'Monimuotoisuus lisää kasvillisuuden vastustuskykyä ilmastonmuutoksen myötä lisääntyviä tuholaisia vastaan. Kuvassa esitetty viitteelisesti  kasvillisuus.',
    itemType: 'HotSpot',
    type: 'info'
  },
  {
    fileName: '2B_360_2.jpg',
    key: '2',
    pitch: 0,
    yaw: -100,
    text:
      'Vihreän infran suunnittelussa suositaan monilajisia sekä kerroksellisia puu-, perenna- ja pensasistutuksia tukemaan kaupunkiekologiaa',
    itemType: 'HotSpot',
    type: 'info'
  },
  {
    fileName: '2B_360_3.jpg',
    key: '1',
    pitch: -30,
    yaw: -5,
    text: 'Aina kun mahdollista, raitiotie toteutetaan viherraiteena.',
    itemType: 'HotSpot',
    type: 'info'
  },
  {
    fileName: '2B_360_4.jpg',
    key: '1',
    pitch: -5,
    yaw: -280,
    text: 'Aina kun mahdollista, raitiotie toteutetaan viherraiteena.',
    itemType: 'HotSpot',
    type: 'info'
  }
];

export const photos = [
  {
    id: '10Irn6oRTRnE86V4OZPTbjVq-olzAu9OC',
    name: '3B_360_1.jpg',
    mimeType: 'image/jpeg',
    parents: ['1tGNbyA03KKvUJN1J7YrNvERRGmbZ_mAr'],
    webContentLink:
      'https://drive.google.com/uc?id=10Irn6oRTRnE86V4OZPTbjVq-olzAu9OC&export=download',
    webViewLink:
      'https://drive.google.com/file/d/10Irn6oRTRnE86V4OZPTbjVq-olzAu9OC/view?usp=drivesdk',
    photo: photo3B_3601,
    photoAlt: photo3B_3601_alt,
    imageMediaMetadata: {
      width: 8192,
      height: 4096,
      rotation: 0,
      location: {
        latitude: 60.200719444444445,
        longitude: 24.964122222222223
      }
    },
    time: null,
    title: 'Nylanderin puiston pysäkki, lintuperspektiivi',
    itemType: 'Photo',
    source: 'Virtuaalimalli',
    hasSameLocs: false
  },
  {
    id: '10HV4Yii8brTk5P8tx3ztOTCSPkPjH0Kp',
    name: '3A_360_2.jpg',
    title: 'Hermannin rantatie 22, lintuperspektiivi',
    mimeType: 'image/jpeg',
    parents: ['1tGNbyA03KKvUJN1J7YrNvERRGmbZ_mAr'],
    webContentLink:
      'https://drive.google.com/uc?id=10HV4Yii8brTk5P8tx3ztOTCSPkPjH0Kp&export=download',
    webViewLink:
      'https://drive.google.com/file/d/10HV4Yii8brTk5P8tx3ztOTCSPkPjH0Kp/view?usp=drivesdk',
    photo: photo3A2,
    photoAlt: photo3A2_alt,
    imageMediaMetadata: {
      width: 8192,
      height: 4096,
      rotation: 0,
      location: {
        latitude: 60.193596388888885,
        longitude: 24.97747611111111
      }
    },
    time: null,
    itemType: 'Photo',
    source: 'Virtuaalimalli',
    hasSameLocs: false
  },
  {
    id: '1-yiKdOPUxdBRQpFOYZqyruwE5A1O2Tl9',
    name: '2B_360_3.jpg',
    title: 'Hermannin rantatie 10, lintuperspektiivi',
    mimeType: 'image/jpeg',
    parents: ['1cqUL28WlU0pvu8SYfKXb2NB_4VsnxK45'],
    webContentLink:
      'https://drive.google.com/uc?id=1-yiKdOPUxdBRQpFOYZqyruwE5A1O2Tl9&export=download',
    webViewLink:
      'https://drive.google.com/file/d/1-yiKdOPUxdBRQpFOYZqyruwE5A1O2Tl9/view?usp=drivesdk',
    photo: photo2B3,
    photoAlt: photo2B3_alt,
    imageMediaMetadata: {
      width: 8192,
      height: 4096,
      rotation: 0,
      location: {
        latitude: 60.19125555555555,
        longitude: 24.978919444444443
      }
    },
    time: null,
    itemType: 'Photo',
    source: 'Virtuaalimalli',
    hasSameLocs: false
  },
  {
    id: '1-wzf4ll4NceZ_gF2_B7B8Gy4fHW79QYu',
    name: '2B_360_1.jpg',
    title: 'Hermannin rantatie 18',
    mimeType: 'image/jpeg',
    parents: ['1cqUL28WlU0pvu8SYfKXb2NB_4VsnxK45'],
    webContentLink:
      'https://drive.google.com/uc?id=1-wzf4ll4NceZ_gF2_B7B8Gy4fHW79QYu&export=download',
    webViewLink:
      'https://drive.google.com/file/d/1-wzf4ll4NceZ_gF2_B7B8Gy4fHW79QYu/view?usp=drivesdk',
    photo: photo2B1,
    photoAlt: photo2B1_alt,
    imageMediaMetadata: {
      width: 8192,
      height: 4096,
      rotation: 0,
      location: {
        latitude: 60.19242777777777,
        longitude: 24.978044444444443
      }
    },
    time: null,
    itemType: 'Photo',
    source: 'Virtuaalimalli',
    hasSameLocs: false
  },
  {
    id: '10-F2vcFjjOKEvujoHEtmVAQOKAnGrRRG',
    name: '2B_360_2.jpg',
    title: 'Hermannin rantatie 10, katutaso',
    mimeType: 'image/jpeg',
    parents: ['1cqUL28WlU0pvu8SYfKXb2NB_4VsnxK45'],
    webContentLink:
      'https://drive.google.com/uc?id=10-F2vcFjjOKEvujoHEtmVAQOKAnGrRRG&export=download',
    webViewLink:
      'https://drive.google.com/file/d/10-F2vcFjjOKEvujoHEtmVAQOKAnGrRRG/view?usp=drivesdk',
    photo: photo2B2,
    photoAlt: photo2B2_alt,
    imageMediaMetadata: {
      width: 8192,
      height: 4096,
      rotation: 0,
      location: {
        latitude: 60.19113333333333,
        longitude: 24.979252777777777
      }
    },
    time: null,
    itemType: 'Photo',
    source: 'Virtuaalimalli',
    hasSameLocs: false
  },
  {
    id: '1-x9T_L0feSR8qy6B8MBNYh-ahT7-Pq24',
    name: '2B_360_4.jpg',
    title: 'Hermannin rantatie 4',
    mimeType: 'image/jpeg',
    parents: ['1cqUL28WlU0pvu8SYfKXb2NB_4VsnxK45'],
    webContentLink:
      'https://drive.google.com/uc?id=1-x9T_L0feSR8qy6B8MBNYh-ahT7-Pq24&export=download',
    webViewLink:
      'https://drive.google.com/file/d/1-x9T_L0feSR8qy6B8MBNYh-ahT7-Pq24/view?usp=drivesdk',
    photo: photo2B4,
    photoAlt: photo2B4_alt,
    imageMediaMetadata: {
      width: 8192,
      height: 4096,
      rotation: 0,
      location: {
        latitude: 60.189655555555554,
        longitude: 24.97806111111111
      }
    },
    time: null,
    itemType: 'Photo',
    source: 'Virtuaalimalli',
    hasSameLocs: false
  },
  {
    id: '10M3uPJJ6hMZU8YN3N7UBL78s5JXSl4cr',
    name: '3B 3.jpg',
    title: 'Nylanderin puiston pysäkki, katutaso 2',
    mimeType: 'image/jpeg',
    parents: ['1tGNbyA03KKvUJN1J7YrNvERRGmbZ_mAr'],
    webContentLink:
      'https://drive.google.com/uc?id=10M3uPJJ6hMZU8YN3N7UBL78s5JXSl4cr&export=download',
    webViewLink:
      'https://drive.google.com/file/d/10M3uPJJ6hMZU8YN3N7UBL78s5JXSl4cr/view?usp=drivesdk',
    photo: photo3B3,
    photoAlt: photo3B3_alt,
    imageMediaMetadata: {
      width: 8192,
      height: 4096,
      rotation: 0,
      location: {
        latitude: 60.20073277777778,
        longitude: 24.964066388888888
      }
    },
    time: null,
    itemType: 'Photo',
    source: 'Virtuaalimalli',
    hasSameLocs: false
  },
  {
    id: '108eiM2HmmYHxgFZX56xVM6DL0XT3YMk8',
    name: '3B 1.jpg',
    title: 'Hermannin rantatie 34',
    mimeType: 'image/jpeg',
    parents: ['1tGNbyA03KKvUJN1J7YrNvERRGmbZ_mAr'],
    webContentLink:
      'https://drive.google.com/uc?id=108eiM2HmmYHxgFZX56xVM6DL0XT3YMk8&export=download',
    webViewLink:
      'https://drive.google.com/file/d/108eiM2HmmYHxgFZX56xVM6DL0XT3YMk8/view?usp=drivesdk',
    photo: photo3B1,
    photoAlt: photo3B1_alt,
    imageMediaMetadata: {
      width: 8192,
      height: 4096,
      rotation: 0,
      location: {
        latitude: 60.20039166666667,
        longitude: 24.96524833333333
      }
    },
    time: null,
    itemType: 'Photo',
    source: 'Virtuaalimalli',
    hasSameLocs: false
  },
  {
    id: '10DtulDfMPd2NfqVTA9t8i8d1ZDG89ysN',
    name: '3AB_360_4.jpg',
    title: 'Hermannin rantatie 20, jalkakäytävä',
    mimeType: 'image/jpeg',
    parents: ['1tGNbyA03KKvUJN1J7YrNvERRGmbZ_mAr'],
    webContentLink:
      'https://drive.google.com/uc?id=10DtulDfMPd2NfqVTA9t8i8d1ZDG89ysN&export=download',
    webViewLink:
      'https://drive.google.com/file/d/10DtulDfMPd2NfqVTA9t8i8d1ZDG89ysN/view?usp=drivesdk',
    photo: photo3AB4,
    photoAlt: photo3AB4_alt,
    imageMediaMetadata: {
      width: 8192,
      height: 4096,
      rotation: 0,
      location: {
        latitude: 60.19322777777777,
        longitude: 24.977530555555553
      }
    },
    time: null,
    itemType: 'Photo',
    source: 'Virtuaalimalli',
    hasSameLocs: false
  },
  {
    id: '10DkTBWmmS0i64xKs9GQ215aB-cigW4iC',
    name: '3AB_360_5.jpg',
    title: 'Hermannin rantatie 22, katutaso',
    mimeType: 'image/jpeg',
    parents: ['1tGNbyA03KKvUJN1J7YrNvERRGmbZ_mAr'],
    webContentLink:
      'https://drive.google.com/uc?id=10DkTBWmmS0i64xKs9GQ215aB-cigW4iC&export=download',
    webViewLink:
      'https://drive.google.com/file/d/10DkTBWmmS0i64xKs9GQ215aB-cigW4iC/view?usp=drivesdk',
    photo: photo3AB5,
    photoAlt: photo3AB5_alt,
    imageMediaMetadata: {
      width: 8192,
      height: 4096,
      rotation: 0,
      location: {
        latitude: 60.193638888888884,
        longitude: 24.977705555555556
      }
    },
    time: null,
    itemType: 'Photo',
    source: 'Virtuaalimalli',
    hasSameLocs: false
  },
  {
    id: '100kwsKbDsMmoKwcdJEGH-JHahQGh_7EW',
    name: '3AB_360_3.jpg',
    title: 'Hermannin rantatie 20, tuleva pysäkki',
    mimeType: 'image/jpeg',
    parents: ['1tGNbyA03KKvUJN1J7YrNvERRGmbZ_mAr'],
    webContentLink:
      'https://drive.google.com/uc?id=100kwsKbDsMmoKwcdJEGH-JHahQGh_7EW&export=download',
    webViewLink:
      'https://drive.google.com/file/d/100kwsKbDsMmoKwcdJEGH-JHahQGh_7EW/view?usp=drivesdk',
    photo: photo3AB3,
    photoAlt: photo3AB3_alt,
    imageMediaMetadata: {
      width: 8192,
      height: 4096,
      rotation: 0,
      location: {
        latitude: 60.19322777777777,
        longitude: 24.977866666666664
      }
    },
    time: null,
    itemType: 'Photo',
    source: 'Virtuaalimalli',
    hasSameLocs: false
  },
  {
    id: '107rzCg9imtoYDW7ydeEGemIc2xnlGqk0',
    name: '3B 2.jpg',
    title: 'Nylanderin puiston pysäkki, katutaso 1',
    mimeType: 'image/jpeg',
    parents: ['1tGNbyA03KKvUJN1J7YrNvERRGmbZ_mAr'],
    webContentLink:
      'https://drive.google.com/uc?id=107rzCg9imtoYDW7ydeEGemIc2xnlGqk0&export=download',
    webViewLink:
      'https://drive.google.com/file/d/107rzCg9imtoYDW7ydeEGemIc2xnlGqk0/view?usp=drivesdk',
    photo: photo3B2,
    photoAlt: photo3B2_alt,
    imageMediaMetadata: {
      width: 8192,
      height: 4096,
      rotation: 0,
      location: {
        latitude: 60.20082527777778,
        longitude: 24.963456944444445
      }
    },
    time: null,
    itemType: 'Photo',
    source: 'Virtuaalimalli',
    hasSameLocs: false
  }
];
